import React from "react";
import { Link, Navigate } from "react-router-dom";
import { Avatar, Breadcrumb, Button, Card, Col, Divider, Form, Input, Row, Typography, Upload, message } from "antd";
import { IoAlbums, IoApps, IoArrowBackCircle, IoBusiness, IoClipboard, IoCloseCircle, IoGrid, IoMap, IoPeople, IoMan, IoSettings, IoIdCard, IoCalendar, IoDocument, IoBook, IoCalculator } from "react-icons/io5";
import { RiGraduationCapFill } from "react-icons/ri";

import { POST_API, POST_CATCH, getToken, getUPLOADAPI } from "../services/hello-api";

import Pageload from "../components/Pageload";
import { IoCameraOutline } from "react-icons/io5";

class MenuApresentacaoComercial extends React.Component {

    state = { _loading: true, _navigate: false, _user: null, _menu: false }

    componentDidMount = () => {
        this.onView()
    }

    onView = () => {
        this.setState({_loading: true})
        if (getToken()) {
            POST_API('/credential/verify.php', { token: getToken() }).then(rs => rs.json()).then(res => {
                if (!res.return) {
                    this.setState({_navigate: true})
                } else {
                    this.setState({_user: res.user})
                }
            }).catch(() => POST_CATCH()).finally(() => {
                this.setState({_loading: false})
            })
        } else {
            this.setState({_navigate: true})
        }
    }

    render = ( ) => {

        const routes = this.props.bread

        if (this.state._navigate) return <Navigate to="/" />

        if (this.state._user === null || this.state._loading) return <Pageload />

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={18}>
                            <Breadcrumb items={routes} />
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                        { this.props.ret ? <Link to={this.props.ret}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link> : null }
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content menu">
                    <Row gutter={[16,16]}>
                        <Col xs={12} md={4}>
                            <Link to="#">
                                <Card hoverable className="menu-card">
                                    <center><IoCalendar size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Mostruário</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4}>
                            <Link to="#">
                                <Card hoverable className="menu-card">
                                    <center><IoCalendar size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Apresentação</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4}>
                            <Link to="#">
                                <Card hoverable className="menu-card">
                                    <center><IoDocument size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Demo App</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4}>
                            <Link to="#">
                                <Card hoverable className="menu-card">
                                    <center><IoBook size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Proposta</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4}>
                            <Link to="#">
                                <Card hoverable className="menu-card">
                                    <center><IoCalculator size={20} className="menu-card-icon" /></center>
                                    <center><Typography className="menu-card-text">Fechamento</Typography></center>
                                </Card>
                            </Link>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

}

export default MenuApresentacaoComercial;